import React from "react";
import { Typography } from "../Typography";
import * as S from "./styled";
import { TFilterDividerProps } from "./types";

interface IProps extends TFilterDividerProps {
    orientation: "row" | "column";
}

const FilterDivider = ({ title, orientation }: IProps): JSX.Element => {
    return (
        <S.Divider $orientation={orientation}>
            {title && (
                <Typography variant="label-small-regular" color="primary-500">
                    {title}
                </Typography>
            )}
        </S.Divider>
    );
};

export default FilterDivider;
